import { render, staticRenderFns } from "./PerformanceAssessment.vue?vue&type=template&id=7e51d14c"
import script from "./PerformanceAssessment.vue?vue&type=script&lang=js"
export * from "./PerformanceAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports